import { ethers } from 'ethers';
import { CheckPermit2AllowanceResult } from './types';
import {
  ALLOWED_TO_TOKENS_FOR_ELEVATE_SWAP,
  ELEVATE_MAINNET_TOKENS,
} from './elevateConfig';
import { CryptoAssetType, type CryptoAsset } from '@/types/WalletTypes';

export interface AllowanceProperties {
  currentPermit2Allowance: ethers.BigNumber;
  expiration: ethers.BigNumber;
}

export const parseAllowanceProperties = (
  permit2AllowanceResult: CheckPermit2AllowanceResult
): AllowanceProperties => {
  // Parse allowance - API returns "amount,expiration" format (e.g., "0,0")
  const allowanceStr = permit2AllowanceResult.allowance;
  let currentPermit2Allowance: ethers.BigNumber;
  let expiration: ethers.BigNumber;
  if (typeof allowanceStr === 'string' && allowanceStr.includes(',')) {
    // Parse "amount,expiration" format
    const [amount, exp] = allowanceStr.split(',');
    currentPermit2Allowance = ethers.BigNumber.from(amount || '0');
    expiration = ethers.BigNumber.from(exp || '0');
  } else {
    // Single value format
    currentPermit2Allowance = ethers.BigNumber.from(allowanceStr || '0');
    expiration = ethers.BigNumber.from('0');
  }
  return { currentPermit2Allowance, expiration };
};

// Max uint48 value
export const MAX_UINT48 = ethers.BigNumber.from('281474976710655');

// Max uint160 = 2^160 - 1 = 0xffffffffffffffffffffffffffffffffffffffff
export const MAX_UINT160 = ethers.BigNumber.from(
  '0xffffffffffffffffffffffffffffffffffffffff'
).toString();

export const isAllowedAsElevateTargetToken = (token: {
  contractAddress?: string;
  coinSymbol?: string;
  cryptoAsset?: CryptoAsset;
}): boolean => {
  if (token.cryptoAsset?.asset.assetType?.id === CryptoAssetType.Native) {
    return false;
  }

  const contractAddress =
    token.cryptoAsset?.asset.definitionAddress || token.contractAddress;

  if (!contractAddress) {
    return false;
  }

  return isTokenAddressAllowedAsElevateTargetToken(contractAddress);
};

export const isTokenAddressAllowedAsElevateTargetToken = (
  tokenAddress: string
): boolean => {
  return ALLOWED_TO_TOKENS_FOR_ELEVATE_SWAP.some(
    (allowedAddress) => allowedAddress.toUpperCase() === tokenAddress.toUpperCase()
  );
};

export const isElevateTokenAddress = (tokenAddress: string): boolean => {
  return ELEVATE_MAINNET_TOKENS.ELEVATE.toUpperCase() === tokenAddress.toUpperCase();
};
